import { render } from "./PageNotFound.vue?vue&type=template&id=31e8c166&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=31e8c166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e8c166"]])

export default __exports__